import { Injectable } from '@angular/core';
import { APP_CONFIG } from '@core/configs';
import { Observable, Subject, timer } from 'rxjs';
import { finalize, repeatWhen, switchMapTo, takeUntil, throttleTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AutoLogoutService {
  onLogout: Observable<any>;
  private logoutTimer: number = APP_CONFIG.inActiveTime * 60 * 1000;
  private isStarted = false;
  private readonly _start = new Subject<void>();
  private readonly _stop = new Subject<void>();
  private readonly _subject = new Subject<void>();

  constructor() {
    this.onLogout = this._subject.pipe(
      throttleTime(250),
      switchMapTo(timer(this.logoutTimer)),
      finalize(() => {
        this.stop();
      }),
      takeUntil(this._stop),
      repeatWhen(() => this._start)
    );
  }

  start(): void {
    this.isStarted = true;
    this._start.next();
  }

  stop(): void {
    this.isStarted = false;
    if (!this.isStarted) {
      this._stop.next();
    }
  }

  reset(): void {
    if (this.isStarted) {
      this._subject.next();
    }
  }
}
